module.exports = __webpack_public_path__ + "static/elakepatakka-c09bb2034e68e9f11981ddf6b8984647.png";